// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "Felkod:",
    "error.search": "Sök i vår kunskapsdatabas för mer information",
    dismiss: "avvisa",
    "installation.title": "",
    "cancelation.button": "Avbryt",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "Initialisering misslyckades",
      description: "Vi kunde inte rendera sidan. Vänligen kontakta supporten.",
    },
    "EOS-UI-UE": {
      title: "Ett fel uppstod",
      description: "Ett fel uppstod. Vänligen kontakta supporten.",
    },
    "EOS-IN-BC": {
      title: "Installationen misslyckades",
      description:
        "Vi kunde inte visa installationsstatus. Vänligen kontakta supporten.",
    },
    "EOS-IN-UE": {
      title: "Installationen misslyckades",
      description: "Ett fel uppstod. Vänligen kontakta supporten.",
    },
    "EOS-IN-FF": {
      title: "Installationen misslyckades",
      description:
        "Vi kunde inte ansluta till Epic Online Services. Vänligen kontakta supporten.",
    },
    "EOS-IN-FF-*": {
      title: "Installationen misslyckades",
      description:
        "Vi kunde inte utföra förfrågan till Epic Online Services. Vänligen kontakta supporten.",
    },
    fallback: {
      title: "Ett fel uppstod",
      description: "Ett fel uppstod. Vänligen kontakta supporten.",
    },
  },
};
